import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    disclaimer: {
      pre: 'We doen een proef met AI-antwoorden. Niet gevonden wat je zocht? Stel een nieuwe vraag of bekijk de ',
      link: 'gewone zoekresultaten',
      post: '.',
    },
    feedback: 'Hoe vind je dit antwoord?',
    feedbackThumbsUp: 'Duim omhoog',
    feedbackThumbsDown: 'Duim omlaag',
    feedbackLabel: 'Typ hier je feedback',
    feedbackSuccess: 'Bedankt voor je feedback!',
    noResult: {
      pre: 'Hier hebben we geen antwoord op. Stel je vraag op een andere manier of bekijk de ',
      link: 'gewone zoekresultaten',
      post: '.',
    },
    resetAriaLabel: 'Wissen',
    searchLabel: '<strong>Stel je vraag, AI geeft antwoord.</strong> Gebruik meer woorden voor een beter resultaat.',
    submitAriaLabel: 'Zoeken',
    submitFeedback: 'Verstuur feedback',
  },
  en: {},
};
